<template>
  <div
    style="position:absolute; bottom:10px; right:16px; min-width:20px; font-size:14px; z-index:100000000; cursor:pointer;"
    @click="showTour()"
  >
    <i
      class="fa fa-lightbulb-o fa-2x"
      :title="take_tour_string"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { defaultErrorMessage } from '@/helpers'

export default {
  name: 'StartTour',
  props: {
    tour: {
      required: true,
    },
  },

  computed: {
    take_tour_string () {
      return Lang.get('tours.take_tour')
    },
  },

  mounted () {
    axios.get('/tour/check', { params: { tour: this.tour } }).then((response) => {
      if (!response.data.watched) {
        this.showTour()
      }
    }).catch(error => defaultErrorMessage(error))
  },

  methods: {

    showTour () {
      axios.post('/tour/start', { tour: this.tour }).then(() => {
        if (this.$tours[this.tour] != null) {
          this.$tours[this.tour].start()
        }
      }).catch(error => defaultErrorMessage(error))
    },
  },
}
</script>
